import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { arrayOf, bool, shape } from 'prop-types';
import * as R from 'ramda';
import ItnChip from './ItnChip';

const DestinationsAccordion = ({ defaultExpanded, destinations, showItn }) => {
  const [isExpanded, setExpanded] = useState(defaultExpanded);

  const defaultToEmpty = R.defaultTo('');
  const getFullAddress = ({
    destinationAddress,
    destinationCity,
    destinationState,
    destinationZipCode,
  }) =>
    `${defaultToEmpty(destinationAddress)}${destinationAddress ? ',' : ''} ${defaultToEmpty(
      destinationCity
    )}${destinationCity ? ',' : ''} ${defaultToEmpty(destinationState)} ${defaultToEmpty(
      destinationZipCode
    )}`;

  return (
    <Accordion expanded={isExpanded} onChange={() => setExpanded(!isExpanded)}>
      <AccordionSummary aria-controls="destinations-content" expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" spacing={1}>
          <Typography variant="body2">Loading Control Numbers</Typography>
          {!!destinations.length && (
            <Chip label={destinations.length} type="accordion" variant="badge" />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ px: { md: 3, xs: 2 } }}>
        <Box
          display="grid"
          sx={{
            columnGap: 1.5,
            gridTemplateColumns: { md: '105px 72px auto', xs: '60px 60px auto' },
            mb: 1,
          }}
        >
          <Typography variant="caption">Loading Ctrl ID</Typography>
          <Typography variant="caption">Dest ID</Typography>
          <Typography variant="caption">Destination Name</Typography>
        </Box>
        {destinations.map(
          ({
            idName,
            destinationIdName,
            destinationName,
            destinationAddress,
            destinationCity,
            destinationState,
            destinationZipCode,
            itn,
          }) => (
            <Box
              display="grid"
              key={idName}
              sx={{
                columnGap: 1.5,
                gridTemplateColumns: { md: '105px 72px auto 160px', xs: '60px 60px auto' },
                mb: 2,
                rowGap: 2,
              }}
            >
              <Typography variant="subtitle2">{idName}</Typography>
              <Typography variant="subtitle2">{destinationIdName}</Typography>
              <Stack space={0.5}>
                <Typography variant="subtitle2">{destinationName}</Typography>
                <Typography variant="subtitle2">
                  {getFullAddress({
                    destinationAddress,
                    destinationCity,
                    destinationState,
                    destinationZipCode,
                  })}
                </Typography>
              </Stack>
              <Box sx={{ gridColumn: { md: '4/5', xs: '1/4' } }}>
                {showItn && itn && <ItnChip itn={itn} />}
              </Box>
            </Box>
          )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

DestinationsAccordion.propTypes = {
  defaultExpanded: bool,
  destinations: arrayOf(shape({})),
  showItn: bool,
};

DestinationsAccordion.defaultProps = {
  defaultExpanded: false,
  destinations: [],
  showItn: false,
};

export default DestinationsAccordion;
